import eventBus from 'toxilibs/event_bus_queued.js'
import $ from 'jquery'
import random from 'toxilibs/random.js'
import replaceIconNames from '../modules/icons.js'
import addParticles from './particles.js'

eventBus.on('page loaded', initTemplates)

eventBus.on('challenge created', createChallengeView)

eventBus.on('challenge answer given', addCorrection)

eventBus.on('challenge after answer phase ended', addAfterClass)

eventBus.on('challenge destroyed', removeContainer)





let answerTemplate
let challengeTemplate
let correctionTemplate
let clickHereTemplate

let alwaysTextualCorrection = true


function initTemplates () {
    challengeTemplate       = $('#challenge_template').html()
    answerTemplate          = $('#answer_template').html()
    correctionTemplate      = $('#correction_template').html()
    clickHereTemplate       = $('#click_here_template').html()
}





function createChallengeView (challenge) {

    challenge.container = $(challengeTemplate)

    addQuestion(challenge)

    //FIXME
    challenge.focus = function () {
        if (challenge.input) {
            challenge.input.focus()
        } else {
            // the previous answer field keeps the focus (see addInputCorrection): without a field,
            // the virtual keyboard would stay open over the choices
            document.activeElement.blur()
        }
    }

    if (challenge.question.badChoices) {
        addChoices(challenge)
        challenge.container.addClass('multiple_choices')
    } else {
        addInput(challenge)
        addInputListeners(challenge)
    }


    eventBus.emit('challenge view constructed', challenge)
}




function addCorrection (challenge, userAnswer, status) {
    const htmlClass = status

    challenge.container.addClass(htmlClass)

    if (challenge.question.badChoices) {    //TODO add correction feedback

        if (alwaysTextualCorrection) {


            const placeholder = getAnswerPlaceholder(challenge)
            const goodButton = challenge.answerContainer.find('.good_button')

            if (placeholder && status !== 'lose') {
                let start = goodButton.offset()
                let goal  = placeholder.offset()
                goodButton.animate({
                    top:  (goal.top  - start.top) + 'px',
                    left: (goal.left - start.left - 20) + 'px',
                    opacity: 0.2
                }, 500)
            }

            if (status === 'win') {
                addParticles(goodButton)
            }

            setTimeout(() => {
                addTextualCorrection(challenge, {userAnswer, status})
                removeButtons(challenge, placeholder)
            }, 500)

        } else {
            addButtonsCorrection(challenge, userAnswer, status)
        }
    } else {
        addInputCorrection(challenge, userAnswer, status)
    }
}


function removeButtons (challenge, placeholder) {
    const {answerContainer} = challenge
    const correctionHeight = placeholder ? 0 : answerContainer.find('.user_answer_and_correction').outerHeight()
    answerContainer.addClass('retract').css({height: answerContainer.height() + 'px'})
    answerContainer.find('.choice_button').fadeOut(200)
    setTimeout(() => answerContainer.css({height: correctionHeight + 'px'}), 200)
}



function addInputCorrection (challenge, userAnswer, status) {

    //we do not remove the input : it's a hack for mobile users to keep the keyboard opened
    challenge.input.css({
        position: 'absolute',
        top:      '-100px',
        left:     '-2000px',
        'z-index':  '-10'
    })

    challenge.container.find('.interro').remove()

    addTextualCorrection(challenge, {userAnswer, status})
}


function addTextualCorrection (challenge, {userAnswer, status}) {
    if (!userAnswer) {
        userAnswer = '<img src="./icons/late_gray.png" alt="too late" />'
    }

    formatChallengeAnswer(challenge)

    let userAnswerDisplay
    if (userAnswer === "'helpMe'") {
        userAnswerDisplay = '?!?'
    } else {
        userAnswerDisplay = translate(challenge, userAnswer)
    }


    let correctAnswerDisplay = translate(challenge, challenge.answer)


    const placeholder = getAnswerPlaceholder(challenge)

    if (placeholder) {
        challenge.container.find('.answer_placeholder').html(
            '<span class="answer_in_place">' + correctAnswerDisplay + '</span>'
        )
    } else {
        challenge.answerContainer.prepend(correctionTemplate)
        challenge.answerContainer.find('.user_answer').html(userAnswerDisplay)
        if (status !== 'win') {
            challenge.answerContainer.find('.correct_answer').html(correctAnswerDisplay).fadeIn(750)
        }
    }

}


function formatChallengeAnswer (challenge) {
    if (Array.isArray(challenge.answer)) {
        challenge.answer = challenge.answer[0]
    }

    //FIXME modularize instead of dontQuoteAnswer option
    if (!challenge.question.dontQuoteAnswer && typeof challenge.answer === 'string') {
        challenge.answer = "'" + challenge.answer + "'"
    }
}


function getAnswerPlaceholder (challenge) {
    const placeholder = challenge.container.find('.answer_placeholder')
    if (placeholder.length === 0) {
        return false
    } else {
        return placeholder
    }
}


function addButtonsCorrection (challenge, userAnswer, status) {
    const correctButton = challenge.answerContainer.find('button[value="' + challenge.answer + '"]')
    correctButton.addClass('win')

    if (status !== 'win') {
        if (userAnswer[0] === "'") {     //FIXME: challenge.js add single quote and I remove it here
            userAnswer = userAnswer.split("'")[1]
        }
        const selectedButton = challenge.answerContainer.find('button[value="' + userAnswer + '"]')
        selectedButton.addClass('lose')
    }
}


function addAfterClass (challenge) {
    challenge.answerContainer.addClass('after')
}



function removeContainer (challenge) {
    challenge.container.remove()
}




function addQuestion (challenge) {
    challenge.container.append(challenge.question.container)
}



function addInput (challenge) {
    challenge.answerContainer = $(answerTemplate)
    challenge.input = challenge.answerContainer.find('input')
    challenge.input.attr('type', inputType(challenge.answer))

    challenge.container.append(challenge.answerContainer)
}


function addInputListeners (challenge) {
    challenge.input.keydown(function (event) {
        if (!canSubmitAnswer(challenge)) {
            return
        }

        if (event.keyCode === 13) {
            event.preventDefault()
            submitAnswer(challenge)
        }
    })

    challenge.container.find('.button').click(function () {
        if (!canSubmitAnswer(challenge)) {
            return
        }
        submitAnswer(challenge)
    })

    challenge.container.on('click', function () {
        challenge.focus()
    })
}



const badChoicesCount = 10


function generateChoices (question, answer) {
    const {badChoices, makeItEasy} = question

    const results = []
    const choiceGenerators = []

    badChoices.forEach((badChoice) => {
        if (typeof badChoice === 'function') {
            choiceGenerators.push(badChoice)
        } else if (results.indexOf(badChoice) === -1 && badChoice !== answer) {
            results.push(badChoice)
        }
    })

    if (choiceGenerators.length > 0) {
        let count = (clickHereDisplayed > 1 && makeItEasy) ? 3 : badChoicesCount
        fillWithGeneratedChoices({results, choiceGenerators, answer, count})
    }

    return results
}



function fillWithGeneratedChoices ({results, choiceGenerators, answer, count}) {
    let generatorIndex = 0
    let tries = 0
    while (results.length < count && tries < 40) {
        const value = choiceGenerators[generatorIndex]()
        if (results.indexOf(value) === -1 && value !== answer) {
            results.push(value)
        }
        generatorIndex = (generatorIndex + 1) % choiceGenerators.length
        tries++
    }
}


let usedHelpOnlyCount = 0
let clickHereDisplayed = 0

eventBus.on('question changed', function () {
    usedHelpOnlyCount  = 0
    clickHereDisplayed = 0
})


function addChoices (challenge) {
    challenge.answerContainer = $('<div class="answer">')

    let answerDisplay = translate(challenge, challenge.answer)
    let goodButton    = choiceButton(challenge.answer, challenge, answerDisplay)

    goodButton.addClass('good_button')

    let buttons = [goodButton]

    const badChoices = generateChoices(challenge.question, challenge.answer)

    badChoices.forEach((choice) => {
        let display = translate(challenge, choice)
        buttons.push(choiceButton(choice, challenge, display))
    })

    random.shuffleArray(buttons)

    if (!(usedHelpOnlyCount > 3)) {
        buttons.push(helpMeButton(challenge))
    }

    let $currentRow
    let rowChange = buttons.length < 7 ? Infinity : Math.ceil(buttons.length / 2)

    buttons.forEach((button, index) => {
        if (index === 0 || index === rowChange) {
            $currentRow = $('<div class="row">')
            challenge.answerContainer.append($currentRow)
        }
        $currentRow.append(button)
    })

    challenge.container.append(challenge.answerContainer)
}


let clickHereTimer

function helpMeButton (challenge) {
    const helpButton = choiceButton('helpMe', challenge, '?!?')
    helpButton.addClass('helpMe_button')
    if (challenge.question.pointToHelpMe) {
        if (clickHereDisplayed === 0) {
            helpButton.append(clickHereTemplate)
            clickHereDisplayed += 1
        } else if (clickHereDisplayed === 1) {
            clickHereTimer = setTimeout(() => {
                helpButton.append(clickHereTemplate)
                clickHereDisplayed += 1
            }, 5000)
        }
    }
    return helpButton
}


function choiceButton (answer, challenge, display = answer) {
    if (display === answer && typeof display === 'string' && display[0] !== "'") {
        display = "'" + display + "'"
    }
    const button = $('<button class="choice_button" value="' + answer + '">' + display + '</button>')
    addButtonListener(button, challenge, answer)
    return button
}


//FIXME
function translate (challenge, value) {
    let {question} = challenge
    if (question.translateChoice) {
        return question.translateChoice(value)
    } else if (typeof value === 'string') {
        return replaceIconNames(value)
    } else if (!value) { //eslint-disable-line no-negated-condition
        return value.toString()
    } else {
        return value
    }
}


function addButtonListener (button, challenge, answer) {
    button.on('click', function () {
        clearTimeout(clickHereTimer)
        if (answer === 'helpMe') {
            enableHelpMeMode(challenge)
            return
        }

        if (canSubmitAnswer(challenge)) {
            if (challenge.helpMeMode) {
                if (button.hasClass('good_button')) {
                    answer = 'helpMe'
                } else {
                    return
                }
            } else {
                button.addClass('clicked')
                usedHelpOnlyCount = false
            }
            challenge.submitAnswer(String(answer)) //FIXME maybe better whithout conversion
        }
    })
}

function enableHelpMeMode (challenge) {
    let {container} = challenge
    challenge.helpMeMode = true
    if (usedHelpOnlyCount !== false) {
        usedHelpOnlyCount += 1
    }
    container.find('.click_here').remove()
    container.addClass('helpMe')
}


function canSubmitAnswer (challenge) {
    if (challenge.answerSubmitted || challenge.wasTooLate) {
        return false
    }

    challenge.timer.addBonusDelay()

    return true
}




function submitAnswer (challenge) {
    challenge.submitAnswer(challenge.input.val())
}





function inputType (answer) {
    if (!isIOS()) {
        return 'text'
    }

    if (typeof answer === 'number') {
        return 'number'
    }

    if (typeof answer === 'string') {
        const s = answer.replace(/^0*/g, '') // removing leading zeros
        if (String(parseInt(s, 10)) === s) {
            return 'number'
        }
    }

    return 'text'
}




function isIOS () {
    return navigator.userAgent.match(/(iPod|iPhone|iPad)/) && navigator.userAgent.match(/AppleWebKit/)
}




